const { CURRENCIES_SYMBOLS } = require('constants/currencies');

const currencySymbol = currencyCode => CURRENCIES_SYMBOLS[currencyCode];

module.exports = currencySymbol;
